/**
 * @file firebase.ts
 * @path apps/website/src/lib/firebase.ts
 * @description
 */

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFunctions } from "firebase/functions";
import {
  initializeAppCheck,
  ReCaptchaV3Provider,
} from "firebase/app-check";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBTuSelm3IXo0ZKIAeW_2LeGcT4HiPjBhs",
  authDomain: "sirbastianspro.firebaseapp.com",
  projectId: "sirbastianspro",
  storageBucket: "sirbastianspro.firebasestorage.app",
  messagingSenderId: "150523327848",
  appId: "1:150523327848:web:da2300e07b8e03a2de52dd"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// App Check (reCAPTCHA v3) — bot protection for callable functions.
// Site key is public; secret is held by Google reCAPTCHA + Firebase backend.
if (typeof window !== "undefined") {
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(
        "6LcSPiQtAAAAAKu8UGZ1L1ZVUyzw26YjymMCrDPo",
      ),
      isTokenAutoRefreshEnabled: true,
    });
  } catch (err) {
    // Already initialized (e.g. HMR) — safe to ignore.
    console.warn("App Check init skipped:", err);
  }
}

const functions = getFunctions(app, 'europe-west1');
export default functions;